export default __webpack_public_path__ + "static/media/ipad.f468eb15.png";